import { Pipe, PipeTransform } from '@angular/core';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';

@Pipe({
  name: 'datezSms',
  standalone: false,
})
export class DatezSmsPipe implements PipeTransform {
  private currentYear: number = new Date().getFullYear();
  private dateObject: any;
  private dayjs = dayjs;

  constructor() {
    dayjs.extend(utc);
    dayjs.extend(dayjsTimezone);
  }

  public transform(
    date: string | number | Date,
    timezone: string,
    customFormats: object = {
      today: null,
      yesterday: null,
      default: null,
    }
  ): string {
    if (!date) {
      return;
    }
    this.dateObject = timezone
      ? this.dayjs(date).tz(timezone)
      : this.dayjs(date);
    return this.handleFormats(customFormats);
  }

  private handleFormats(formats): string {
    if (this.dateObject.year() !== this.currentYear) {
      const yearFormat = 'MMM D, YYYY';
      return this.dateObject.format(yearFormat);
    }

    const label = this.getDateLabel();
    switch (label) {
      case 'today':
        return (
          (formats.today && this.dateObject.format(formats.today)) || 'Today'
        );
      case 'yesterday':
        return (
          (formats.yesterday && this.dateObject.format(formats.yesterday)) ||
          'Yesterday'
        );
      default:
        return (
          (formats.default && this.dateObject.format(formats.default)) ||
          this.dateObject.format('ddd, MMM D')
        );
    }
  }

  private getDateLabel(): 'today' | 'yesterday' | 'default' {
    const currentDate = dayjs();
    const convoDate = dayjs(this.dateObject);
    if (convoDate.isSame(currentDate, 'day')) {
      return 'today';
    }
    if (convoDate.isSame(currentDate.subtract(1, 'days'), 'day')) {
      return 'yesterday';
    }
    return 'default';
  }
}
